"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommunicationSignalingClient = exports.ConnectionState = void 0;
const tstrouter_1 = require("@skype/tstrouter");
const TrouterUtils_1 = require("./TrouterUtils");
const TrouterSettings_1 = require("./TrouterSettings");
const constants_1 = require("./constants");
var ConnectionState;
(function (ConnectionState) {
    ConnectionState[ConnectionState["Unknown"] = 0] = "Unknown";
    ConnectionState[ConnectionState["Connected"] = 2] = "Connected";
    ConnectionState[ConnectionState["Disconnected"] = 3] = "Disconnected";
    ConnectionState[ConnectionState["Switching"] = 9] = "Switching";
})(ConnectionState || (exports.ConnectionState = ConnectionState = {}));
class CommunicationSignalingClient {
    constructor(credential, logger, options) {
        this.credential = credential;
        this.logger = logger;
        this.options = options;
        this.stateChangedListener = null;
        this.tokenFetchRetries = 0;
        this.trouter = (0, tstrouter_1.createTrouterService)((0, TrouterUtils_1.toLogProvider)(logger));
    }
    start() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            this.resourceEndpoint = (_a = this.options) === null || _a === void 0 ? void 0 : _a.resourceEndpoint;
            if (this.resourceEndpoint === undefined) {
                throw new Error("'endpoint' cannot be null");
            }
            this.gatewayApiVersion = ((_b = this.options) === null || _b === void 0 ? void 0 : _b.gatewayApiVersion) || "2024-03-07";
            if (this.config === undefined) {
                this.config = {
                    trouterSettings: yield (0, TrouterSettings_1.createSettings)(this.credential, this.options),
                    skypeTokenProvider: (forceRefresh) => __awaiter(this, void 0, void 0, function* () {
                        if (forceRefresh) {
                            this.tokenFetchRetries += 1;
                            if (this.tokenFetchRetries > constants_1.MAX_NUMBER_OF_TOKEN_FETCH_RETRIES) {
                                yield this.stop(true);
                                throw new Error(`Access token is expired and failed to fetch a valid one after ${constants_1.MAX_NUMBER_OF_TOKEN_FETCH_RETRIES} retries`);
                            }
                        }
                        else {
                            this.tokenFetchRetries = 0;
                        }
                        return Promise.resolve((yield this.credential.getToken()).token);
                    }),
                    telemetryConfig: {
                        eventLogger: (0, TrouterUtils_1.toTelemetrySender)(this.logger),
                        settings: TrouterSettings_1.defaultTelemetrySettings,
                    },
                };
            }
            this.trouter.start(this.config);
            this.trouter.setUserActivityState(tstrouter_1.UserActivityState.Active);
        });
    }
    stop(isTokenExpired) {
        return __awaiter(this, void 0, void 0, function* () {
            this.trouter.offStateChanged(this.stateChangedListener);
            this.trouter.clearMessageHandlers();
            this.trouter.stop(isTokenExpired !== null && isTokenExpired !== void 0 ? isTokenExpired : this.tokenFetchRetries > constants_1.MAX_NUMBER_OF_TOKEN_FETCH_RETRIES);
        });
    }
    on(event, listener) {
        if (event === "connectionChanged") {
            this.trouter.offStateChanged(this.stateChangedListener);
            this.stateChangedListener = (state, _url) => listener(state);
            this.trouter.onStateChanged(this.stateChangedListener);
            return;
        }
        this.trouter.registerMessageHandler((0, TrouterUtils_1.toMessageHandler)(event, listener, this.resourceEndpoint, this.gatewayApiVersion));
    }
}
exports.CommunicationSignalingClient = CommunicationSignalingClient;
